import { render, staticRenderFns } from "./number.vue?vue&type=template&id=30dcdd7a&scoped=true&"
import script from "./number.vue?vue&type=script&lang=js&"
export * from "./number.vue?vue&type=script&lang=js&"
import style0 from "./number.vue?vue&type=style&index=0&id=30dcdd7a&prod&lang=scss&"
import style1 from "./number.vue?vue&type=style&index=1&id=30dcdd7a&prod&lang=scss&scoped=true&"
import style2 from "./number.vue?vue&type=style&index=2&id=30dcdd7a&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "30dcdd7a",
  null
  
)

export default component.exports